// src/HomePage/Game/Werewolf/Werewolf.js
import React, { useState } from 'react';
import { WerewolfProvider, useWerewolf } from './WerewolfContext';
import WerewolfLobby from './WerewolfLobby';
import WerewolfRoomView from './WerewolfRoomView';
import WerewolfGameView from './WerewolfGameView';
import WerewolfHistoryView from './WerewolfHistoryView';
import './Werewolf.css';

const WerewolfContent = () => {
  const { currentRoom, isAuthenticated } = useWerewolf();
  const [viewHistory, setViewHistory] = useState(false);

  // 🔒 THÔNG BÁO YÊU CẦU ĐĂNG NHẬP (Gọn gàng & Tinh tế)
  if (!isAuthenticated) {
    return (
      <div className="ww-auth-notice-container">
        <div className="ww-auth-notice-card">
          <div className="ww-notice-icon">🔐</div>
          <h3>Yêu Cầu Đăng Nhập</h3>
          <p className="ww-notice-message">
            Trò chơi <strong>Game Ma Sói</strong> dành riêng cho <strong>Thiếu Nhi</strong> và <strong>Giáo Lý Viên</strong>.
          </p>
          <div className="ww-notice-guide">
            <p>💡 <b>Thiếu nhi:</b> Vui lòng chuyển sang tab <i>"🎁 Nhận Sao Mỗi Ngày"</i> để nhập mã ID cá nhân.</p>
            <p>✝️ <b>Giáo lý viên:</b> Vui lòng đăng nhập tài khoản GLV trên hệ thống.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="werewolf-container">
      <div className="werewolf-header">
        <div className="werewolf-header-title-box">
          <span className="werewolf-icon">🐺</span>
          <div>
            <h3>Game Ma Sói - Đêm Huyền Bí</h3>
            <p className="werewolf-subtitle">
              Thử thách trí tuệ, lập luận và tinh thần đồng đội
            </p>
          </div>
        </div>

        <button
          className="ww-btn secondary history-nav-btn"
          onClick={() => setViewHistory(!viewHistory)}
        >
          {viewHistory ? '🎮 Quay Lại Chơi' : '📜 Lịch Sử Đấu'}
        </button>
      </div>

      {viewHistory ? (
        <WerewolfHistoryView onBack={() => setViewHistory(false)} />
      ) : !currentRoom ? (
        <WerewolfLobby />
      ) : currentRoom.status === 'PLAYING' || currentRoom.gameState?.phase === 'ENDED' ? (
        <WerewolfGameView />
      ) : (
        <WerewolfRoomView />
      )}
    </div>
  );
};

const Werewolf = ({ user, isCatechist, studentId }) => {
  return (
    <WerewolfProvider user={user} isCatechist={isCatechist} studentId={studentId}>
      <WerewolfContent />
    </WerewolfProvider>
  );
};

export default Werewolf;